import React from "react";

/**
 * DashboardCharts Component
 * Embeds external dashboard visualization iframe for analytics
 * Displays interactive charts and visualizations from Haya platform
 * @returns {JSX.Element} Embedded dashboard iframe
 */
const DashboardCharts = () => {
  return (
    <div className="w-full h-screen">
      <iframe
        title="Dashboard-charts"
        src="https://haya-visualisation.unifie.io/org1/view-dashboard/p5tn3xz20rqe72v23524wcgl?key=I407M3JAP5a3Gh8j22j9BtgJucFFVgA1"
        width="100%"
        height="100%"
        frameBorder="0"
        allowFullScreen
      />
    </div>
  );
};

export default DashboardCharts;
